import React from 'react';
import { Button } from '../../../ui/Button';
import { PropertyCriteriaSelector } from '../../../shared/PropertyCriteriaSelector';
import { useClientFormContext } from '../contexts/ClientFormContext';
import { FormField } from '../components/FormField';
import { FormRow } from '../components/FormRow';
import { formatPrice } from '../../../../utils/formatters';

interface CriteriaProps {
  onNext: () => void;
}

export const Criteria: React.FC<CriteriaProps> = ({ onNext }) => {
  const { formData, handleInputChange } = useClientFormContext();

  console.log('🎯 Criteria render - formData:', formData);
  console.log('🎯 Criteria render - criteria:', formData.criteria);

  const handleCriteriaChange = (criteriaId: string, value: boolean) => {
    console.log('📝 handleCriteriaChange appelé:', { criteriaId, value });
    
    // Simuler un événement pour handleInputChange
    handleInputChange({
      target: {
        name: `criteria.${criteriaId}`,
        value: value,
        type: 'checkbox',
        checked: value
      }
    } as any);
  };

  const handleBudgetChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/\D/g, '');
    handleInputChange({
      target: {
        name,
        value: numericValue,
        type: 'text'
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <div className="space-y-6">
      <div className="space-y-6">
        <FormRow>
          <FormField label="Type de transaction">
            <select
              name="transactionType"
              value={formData.transactionType}
              onChange={handleInputChange}
              className="w-full"
            >
              <option value="">Sélectionner</option>
              <option value="sale">Achat</option>
              <option value="rent">Location</option>
              <option value="short-rent">Location courte durée</option>
            </select>
          </FormField>

          <FormField label="Type de bien">
            <select
              name="propertyType"
              value={formData.propertyType}
              onChange={handleInputChange}
              className="w-full"
            >
              <option value="">Sélectionner</option>
              <option value="Appartement">Appartement</option>
              <option value="Maison">Maison</option>
              <option value="Promotion">Promotion</option>
              <option value="Terrain">Terrain</option>
              <option value="Commerce">Local commercial</option>
            </select>
          </FormField>
        </FormRow>

        <FormRow>
          <FormField label="Budget minimum">
            <div className="relative">
              <input
                type="text"
                name="minBudget"
                value={formatPrice(formData.minBudget)}
                onChange={handleBudgetChange}
                placeholder="0"
                className="pr-12"
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">
                DA
              </span>
            </div>
          </FormField>

          <FormField label="Budget maximum">
            <div className="relative">
              <input
                type="text"
                name="maxBudget"
                value={formatPrice(formData.maxBudget)}
                onChange={handleBudgetChange}
                placeholder="0"
                className="pr-12"
              />
              <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">
                DA
              </span>
            </div>
          </FormField>
        </FormRow>

        <FormRow>
          <FormField label="Surface minimale (m²)">
            <input
              type="number"
              name="minArea"
              value={formData.minArea}
              onChange={handleInputChange}
              min="0"
              placeholder="Surface minimale souhaitée"
            />
          </FormField>

          <FormField label="Nombre minimum de pièces">
            <input
              type="number"
              name="minRooms"
              value={formData.minRooms}
              onChange={handleInputChange}
              min="0"
              placeholder="Nombre minimum de pièces"
            />
          </FormField>
        </FormRow>

        {formData.propertyType && (
          <FormField label="Critères souhaités">
            <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-lg dark:bg-blue-900/20 dark:border-blue-800">
              <p className="text-sm text-blue-700 dark:text-blue-300">
                <strong>Type sélectionné :</strong> {formData.propertyType}
              </p>
              <p className="text-sm text-blue-600 dark:text-blue-400 mt-1">
                Cochez les critères souhaités par le client
              </p>
            </div>
            <PropertyCriteriaSelector
              propertyType={formData.propertyType}
              selectedCriteria={formData.criteria}
              onChange={handleCriteriaChange}
            />
          </FormField>
        )}
      </div>

      <div className="flex justify-end">
        <Button onClick={onNext}>
          Suivant
        </Button>
      </div>
    </div>
  );
};